<!-- <div class="base"> -->
    <!-- <h1>123</h1>
    <div class="box">
        

        <div class="perfil-header">
            <div class="perfil-picture">
                <img src="assets/logo-black-orange.svg" alt="seller-profile-picture">
            </div>
    
            <div class="perfil-title">
                <h1>Log-in</h1>
            </div>
        </div>

        <form> 
            <div class="input-email">
                <label for="input-email">Digite o email: </label>
                <input [(ngModel)]="usuario.email" name="email" type="email" placeholder="Insira o email de login" required>
            </div>

            <div class="input-password">
                <label for="">Digite a senha: </label>
                <input [(ngModel)]="usuario.senha" name="senha" type="password" placeholder="Digite a Senha" required>
            </div>

            <div class="bnt">
                <button type="submit" (click)="fazerLogin()">Log-in</button>
            </div>
        </form>
    </div> -->
<!-- </div> -->


<main>
    <div class="imagem">
        <img src="assets/img/login.svg" alt="">
    </div>

    <div class="form">
        <form [formGroup]="formLogin" (ngSubmit)="fazerLogin()">
            <h1>Fazer Login</h1>
            <mat-form-field appearance="outline" id="codigo">
                <mat-label>Código da Loja *</mat-label>
                <input #Codigo formControlName="Codigo" type="text" matInput>
                <mat-icon matTooltip="Você encontrará o código da loja acessando o portal, no menu [Monitor de Pedidos - Configuração]" matSuffix>help</mat-icon>
                <mat-error>
                    Código da Loja está vazio
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Email *</mat-label>
                <input #Email formControlName="Email" type="email" matInput>
                <mat-icon matTooltip="O e-mail deve ser cadastrado no portal, no menu [Monitor de Pedidos - Usuários]" matSuffix>info</mat-icon>

                <mat-error>
                    Campo Email está inválido ou vazio
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Senha *</mat-label>
                <input #Senha formControlName="Senha" type="password" matInput>
                <mat-error>
                    Campo Senha está inválido ou vazio
                </mat-error>
            </mat-form-field>

            <mat-checkbox (click)="check()" [checked]="true">Salvar dados para login</mat-checkbox>

            <button mat-flat-button color="primary" class="text-white" type="submit" [disabled]="!formLogin.valid">Entrar</button>
        </form>
    </div>
</main>